import styled from "styled-components";

export const ContentsBox = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`;
